import Button from "@/common/button/button"
import dynamic from "next/dynamic"
import { useFormContext } from "react-hook-form"

const SwedbankPaySeamlessSubmit = dynamic(
  () =>
    import("./gateways/swedbankPaySeamlessSubmit").then(
      (module) => module.SwedbankPaySeamlessSubmit
    ),
  { ssr: false }
)

const BillectaSubmit = dynamic(
  () =>
    import("./gateways/billectaSubmit").then((module) => module.BillectaSubmit),
  { ssr: false }
)

const FormSubmit = dynamic(
  () => import("./gateways/form").then((module) => module.FormSubmit),
  { ssr: false }
)

const SuperOfficeSubmit = dynamic(
  () =>
    import("./gateways/superoffice").then((module) => module.SuperOfficeSubmit),
  { ssr: false }
)

const ScriveSubmit = dynamic(
  () => import("./gateways/scrive").then((module) => module.ScriveSubmit),
  { ssr: false }
)

const BankIdSubmit = dynamic(
  () => import("./gateways/bankIdSubmit").then((module) => module.BankIdSubmit),
  { ssr: false }
)

const BitioSubmit = dynamic(
  () => import("./gateways/bitio").then((module) => module.BitioSubmit),
  { ssr: false }
)

const mapping = {
  credit_card: SwedbankPaySeamlessSubmit,
  swish: SwedbankPaySeamlessSubmit,
  billecta: BillectaSubmit,
  form: FormSubmit,
  trustly: SwedbankPaySeamlessSubmit,
  invoice: SwedbankPaySeamlessSubmit,
  superoffice: SuperOfficeSubmit,
  scrive: ScriveSubmit,
  bankId: BankIdSubmit,
  bitio: BitioSubmit
}

export function SubmitForm({ type, orderSessionId, stepRef, formSettings }) {
  const { watch } = useFormContext()
  const paymentMethod = watch("paymentMethod")

  if (!paymentMethod) {
    return (
      <div className="flex mb-3">
        <Button
          type="submit"
          ariaLabel="Betala"
          theme="lime"
          className="flex justify-center w-full">
          Betala
        </Button>
      </div>
    )
  }

  const Component = mapping[paymentMethod]

  if (!Component) return null

  return (
    <Component
      type={type}
      orderSessionId={orderSessionId}
      stepRef={stepRef}
      formSettings={formSettings}
    />
  )
}
